import { render } from "./details.vue?vue&type=template&id=5266de2c&scoped=true"
import script from "./details.vue?vue&type=script&lang=ts"
export * from "./details.vue?vue&type=script&lang=ts"

import "./details.vue?vue&type=style&index=0&id=5266de2c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5266de2c"

export default script